export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Veridis is a carbon accounting platform that enables you to track and see your carbon footprint in action."},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[{"src":"https://global.localizecdn.com/localize.js"},{"innerHTML":"\n            !function(a){if(!a.Localize){a.Localize={};for(var e=[\"translate\",\"untranslate\",\"phrase\",\"initialize\",\"translatePage\",\"setLanguage\",\"getLanguage\",\"detectLanguage\",\"getAvailableLanguages\",\"untranslatePage\",\"bootstrap\",\"prefetch\",\"on\",\"off\",\"hideWidget\",\"showWidget\",\"getSourceLanguage\"],t=0;t<e.length;t++)a.Localize[e[t]]=function(){}}}(window);\n          Localize.initialize({\n            key: 'C7jSQLCUE0Wnl', \n            rememberLanguage: true,\n            autoApprove: true,\n            disableWidget: true,\n            vueSafe: true,\n            blockedClasses: ['no-localize-translate']\n          });\n          ","type":"text/javascript"}],"noscript":[],"title":"Veridis | End-to-end carbon accounting platform","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false